export const NO_OP_FUNCTION = () => {
  // Do nothing
};
